module.exports = __webpack_public_path__ + "static/mccarthy-hall-1-thumb-771394f817816a744472e60cfed674de.jpg";